import type { PreferenceValueMap } from "src/shared/config/preferenceDefinitions"
import { buildPreferenceKeys, definePreference } from "src/shared/config/preferenceDefinitions"

export const userPreferenceDefinitions = {
  expandedView: definePreference<boolean>()({
    key: "expanded-view",
    kind: "boolean",
  }),
  editLedger: definePreference<boolean>()({
    key: "edit-ledger",
    kind: "boolean",
  }),
  vaultListView: definePreference<boolean>()({
    key: "vault-list-view",
    kind: "boolean",
    defaultValue: true,
  }),
  firmDashboardListView: definePreference<boolean>()({
    key: "firm-dashboard.list-view",
    kind: "boolean",
    defaultValue: false,
  }),
  allClientsPreferredFirmId: definePreference<string | undefined>()({
    key: "all-clients.preferred-firm-id",
    kind: "string",
  }),
  viewedAssistant: definePreference<boolean>()({
    key: "viewed-assistant",
    kind: "boolean",
  }),
  agentBar: definePreference<{ view: "default" | "collapsed" } | undefined>()({
    key: "agent-bar",
    kind: "json",
  }),
  transactionDimensionColumn: definePreference<string | undefined>()({
    key: "transaction-dimension-column",
    kind: "string",
  }),
  ledgerCategoryPanelWidth: definePreference<number | undefined>()({
    key: "ledger-category-panel-width",
    kind: "number",
  }),
  sidePanelCollapsed: definePreference<boolean>()({
    key: "side-panel-collapsed",
    kind: "boolean",
    defaultValue: false,
  }),
  orgDashboardPreferredOrgId: definePreference<string | undefined>()({
    key: "org-dashboard.preferred-org-id",
    kind: "string",
  }),
} as const

export const userPreferenceKeys = buildPreferenceKeys(userPreferenceDefinitions)

export type UserPreferenceValueMap = PreferenceValueMap<typeof userPreferenceDefinitions>
